import alt from 'components/Dispatcher';
import CardProfileSource from 'sources/CardProfileSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class CardProfileActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetch', 'fetchAll', 'update', 'create'));
  }
  fetch(id) {
    return dispatch => {
      dispatch();
      return CardProfileSource.fetch(id).then(this.fetchSuccess, this.fetchError);
    };
  }
  fetchAll() {
    return dispatch => {
      dispatch();
      return CardProfileSource.fetchAll().then(this.fetchAllSuccess, this.fetchAllError);
    };
  }
  create(profile, shouldOverwrite) {
    return dispatch => {
      dispatch();
      return CardProfileSource.create(profile, shouldOverwrite).then(this.createSuccess, error => {
        this.createError(error);
        throw error;
      });
    };
  }
  update(profile, shouldOverwrite) {
    return dispatch => {
      dispatch();
      return CardProfileSource.update(profile, shouldOverwrite).then(this.updateSuccess, error => {
        this.updateError(error);
        throw error;
      });
    };
  }
}

export default alt.createActions(CardProfileActions);
